// pages/MyRequest.tsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  SvgIcon,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { useLocation, useNavigate } from "react-router-dom";
import CommonTable2, {
  type Column,
} from "../../Components/CommonTable/CommonTable2";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import { myRequestRead } from "../../../../Redux/Slices/Booklet/Tutor/MyRequest/MyRequestRead";
import { MyRequestItem } from "./IMy_request";
import { ReactComponent as filterlogo } from "../../assets/images/Group 1171276895.svg";
import SearchIcon from "@mui/icons-material/Search";
type RequestStatus = "pending" | "approved" | "rejected";

const columns = [
  { field: "id", headerName: "Request ID", sortable: true },
  { field: "date", headerName: "Date", sortable: true },
  { field: "year_levels", headerName: "Year Level" },
  { field: "status", headerName: "Status", sortable: true },
  { field: "printing_status", headerName: "Printing Status" },
  { field: "action", headerName: "Action" },
];

const MyRequest: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<RequestStatus>("pending");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const Selected_request = location.state?.request_id;

  // Select data from Redux
  const { data: response, isLoading } = useAppSelector(
    (state) => state.MyRequestReadSlice
  );

  useEffect(() => {
    if (Selected_request) {
      dispatch(myRequestRead({ req_ids: Selected_request }));
    } else {
      dispatch(myRequestRead({}));
    }
  }, [dispatch, Selected_request]);

  const requests: MyRequestItem[] = Array.isArray(response?.data)
    ? (response?.data as MyRequestItem[])
    : [];

  // Transform API response → table rows
  const mappedData = requests?.map((item) => ({
    id: item.request_id,
    date: new Date(item.created_at).toLocaleDateString("en-GB"),
    year_levels: Array.isArray(item.year_levels)
      ? Array.from(
          new Set(
            item.year_levels
              .map((yl) => yl.year_group?.year_group)
              .filter(Boolean) // remove null/undefined
          )
        )
      : [],

    status:
      item.approval_status === "approved"
        ? "Approved"
        : item.approval_status === "rejected"
        ? "Rejected"
        : "Pending",

    printing_status:
      item.printing_status === "not_yet_started"
        ? "Not Yet Started"
        : item.printing_status === "in_progress"
        ? "In Progress"
        : item.printing_status === "completed"
        ? "Completed"
        : item.printing_status === "failed"
        ? "Failed"
        : "-", // fallback if printing_status is undefined or unknown
  }));

  // Filter based on selected tab
  const filteredData = mappedData.filter(
    (row) => row.status.toLowerCase() === selectedTab
  );

  const finalRows = Selected_request
    ? mappedData
    : mappedData.filter((row) => row.status.toLowerCase() === selectedTab);
  // console.log(filteredData, "filteredData");

  return (
    <Box p={3}>
      {/* Tab Switch */}

      <Box
        sx={{
          mb: 3,
          display: "flex",
          gap: "10px",
          justifyContent: "space-between",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
            My Requests
          </Typography>
        </Grid>
        {/* <Grid
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <SvgIcon
            component={filterlogo}
            inheritViewBox
            sx={{
              height: 37,
              color: "#009DDF",
              fontSize: "32px",
              cursor: "pointer",
            }}
          />

          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              background: "#f2f2f2",
              borderRadius: "8px",
              padding: "5px 12px",
              width: "300px",
            }}
          >
            <span
              style={{
                marginRight: "8px",
                fontSize: "18px",
                color: "#555",
              }}
            >
              <SearchIcon />
            </span>
            <input
              type="text"
              placeholder="Search Topic Here"
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                fontSize: "16px",
                flex: 1,
              }}
            />
          </Grid>
        </Grid> */}
      </Box>

      {!Selected_request && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row ",
            gap: "20px",
            marginBottom: "20px",
          }}
        >
          {[
            { key: "pending", label: "Pending" },
            { key: "approved", label: "Approved" },
            { key: "rejected", label: "Rejected" },
          ].map((tab) => (
            <Button
              key={tab.key}
              variant={selectedTab === tab.key ? "contained" : "outlined"}
              onClick={() => setSelectedTab(tab.key as RequestStatus)}
              sx={{
                fontSize: "12px",
                color: selectedTab === tab.key ? "#ffffff" : "#009DFF",
                bgcolor: selectedTab === tab.key ? "#009DFF" : "transparent",
                borderRadius: "8px",
                textTransform: "none",
                borderColor: "#009DFF",
                "&:hover": {
                  opacity: 0.8,
                  bgcolor: selectedTab === tab.key ? "#009DFF" : "transparent",
                },
              }}
            >
              {tab.key.charAt(0).toUpperCase() + tab.key.slice(1)}
            </Button>
          ))}
        </Box>
      )}

      {/* Table */}
      <CommonTable2
        columns={columns}
        rows={finalRows.map((row) => ({
          ...row,
          action:
            row.status === "Pending" ? (
              <IconButton
                sx={{
                  backgroundColor: "#75bef8",
                  color: "#ffffff",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#4a90e2", // change to your hover color
                    color: "#ffffff", // optional: change text color on hover
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation(); // prevent row click
                  navigate("/my_requests/request_details", {
                    state: { request_id: row.id, isEdit: true },
                  });
                }}
              >
                <EditIcon />
              </IconButton>
            ) : (
              <IconButton
                sx={{
                  backgroundColor: "#75bef8",
                  color: "#ffffff",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#4a90e2", // change to your hover color
                    color: "#ffffff", // optional: change text color on hover
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation(); // prevent row click
                  navigate("/my_requests/request_details", {
                    state: { request_id: row.id },
                  });
                }}
              >
                <VisibilityIcon />
              </IconButton>
            ),
        }))}
        // onRowClick={(row) =>
        //   navigate("/my_requests/request_details", {
        //     state: { request_id: row.id },
        //   })
        // }
      />
    </Box>
  );
};

export default MyRequest;
